/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_IntroInputs */

const en_faq_intro = /** @type {(inputs: Faq_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The practical details of building a system and working together.`)
};

const lv_faq_intro = /** @type {(inputs: Faq_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praktiskās detaļas par sistēmas izveidi un kopīgu darbu.`)
};

/**
* | output |
* | --- |
* | "The practical details of building a system and working together." |
*
* @param {Faq_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_intro = /** @type {((inputs?: Faq_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_intro(inputs)
	return en_faq_intro(inputs)
});